import { useEffect, useState } from 'react';
import {
  Button,
  IconButton,
  Paper,
  Grid,
  Avatar,
  Input,
  TextField,
  FormControlLabel,
  Checkbox,
  CardHeader,
  FormControl,
  InputLabel,
  FormHelperText,
  FormLabel,
  RadioGroup,
  Radio,
  InputAdornment,
} from '@material-ui/core';
import { useStyles } from './style';
import DoctariModal from '../../components/Modal';
import { DropzoneArea } from 'material-ui-dropzone';
import { connect } from 'react-redux';
import { APPOINTMENTS, BASE_PAYMENT, AGENDA } from '../../utils/urls';
import { userActionsTypes } from '../../redux/user/actions';
import { appointmentActionsTypes } from '../../redux/appointment/actions';
import AutocompleteInfo from '../../components/AutocompleteInfo';
import { useHistory, useLocation } from 'react-router';
import moment from 'moment';
import { SearchOutlined } from '@material-ui/icons';

function AppointmentLight({
  getUser,
  createAppointmentLight,
  appointmentsData,
  session,
  userData,
  addUserInfo,
  deleteUserInfo,
  createInfo,
  uploadAppointmentFiles,
  uploadConsentFile,
  deleteAttachmentMessages,
  deleteMessages,
  doctors,
  deleteSchedule,
  getPatientAnonymous,
  createPatientAnonymous,
  clearInformationAppointment,
  clearPatientAnonymous,
  updatePatientAnonymous,
}) {
  const history = useHistory();
  const location = useLocation();
  const styles = useStyles();
  const [attachmentModalOpen, setAttachmentModalOpen] = useState(false);
  const [uploadingAttachmentConsent, setUploadingAttachmentConsent] = useState(false);
  const [uploadingAttachmentStudies, setUploadingAttachStudies] = useState(false);
  const [createAppointmentModalOpen, setCreateAppointmentModalOpen] =
    useState(false);
  const [checked, setChecked] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [consentFile, setConsentFile] = useState(null);
  const [input, setInput] = useState('');
  const isAssistant = session.userType == 'assistant';
  const isOperator = session.userType == 'operator';
  const [identity_document, setIdentityDocument] = useState(null);
  const [isExistPatient, setIsExistPatient] = useState(true);
  const [loading, setLoading] = useState(false);
  const [dataPatient, setDataPatient] = useState({
    id: null,
    name: null,
    lastName: null,
    country: null,
    document: null,
    email: null,
    phone: null,
    password: null,
    password2: null,
    dateOfBirth: moment().add(-18, 'years').format('YYYY-MM-DD'),
    termsAndConditions: false,
    city: null,
    gender: null,
  });

  const {
    name,
    lastName,
    country,
    phone,
    document,
    email,
    password,
    password2,
    termsAndConditions,
    dateOfBirth,
    city,
    gender,
  } = dataPatient;
  const [patientSelected, setPatient] = useState({
    patient: null,
    medications: null,
    allergies: null,
    diseases: null,
  });

  const [injuredArea, setInjuredArea] = useState("");
  const [physicalExamination, setPhysicalExamination] = useState("");
  const [symptoms, setSymptoms] = useState("");
  const [symptomsTime, setSymptomsTime] = useState("");
  const [spo2, setSpo2] = useState("");
  const [glucose, setGlucose] = useState("");
  const [systolicPressure, setSystolicPressure] = useState("");
  const [diastolicPressure, setDiastolicPressure] = useState("");
  const [heartRate, setHeartRate] = useState("");
  const [temperature, setTemperature] = useState("");
  const [respiratoryRate, setRespiratoryRate] = useState("");

  const [patientAllergies, setPatientAllergies] = useState([]);

  const goPayment = () => {
    history.push({
      pathname: `${BASE_PAYMENT}${appointmentsData.appointmentCreated.id}`,
      state: {
        appointmentDate: location.state.schedule.start,
        doctorName: location.state.schedule.doctor.full_name,
      },
    });
    return () => deleteAttachmentMessages();
  };
  // when the appointment files are added  we go to payment page and pass the appointment id
  useEffect(() => {
    if (appointmentsData.success.uploadFiles && buttonClicked && !isAssistant) {
      goPayment();
    } else if (isAssistant && buttonClicked) {
      history.push(AGENDA);
    }
  }, [appointmentsData.success.uploadFiles]);

  // when the appointment is created we upload the attachments
  useEffect(() => {
    console.log(appointmentsData);
    if (
      appointmentsData.success.genericMessage == 'Appointment creado con exito' &&
      buttonClicked &&
      consentFile
    ) {
      const body = {
        file: consentFile,
        fileType: consentFile.type,
        appointmentId: appointmentsData?.appointmentCreated.id,
      };
      uploadConsentFile(body);
    } else if (
      buttonClicked && (
        appointmentsData.success.genericMessage == 'Appointment creado y consentimiento subido con exito' ||
        appointmentsData.success.genericMessage == 'Appointment creado y adjuntos subidos con exito' ||
        (
          appointmentsData.success.genericMessage == 'Appointment creado con exito' && !consentFile
        )
      )
    ) {
      if (attachments.length == 0 && !isAssistant) {
        goPayment();
      } else if (attachments.length > 0) {
        const formDataAppointment = new FormData();
        for (let i = 0; i < attachments.length; i++) {
          console.log(`file${i}`);
          formDataAppointment.append(`file${i}`, attachments[i]);
        }
        const body = {
          files: formDataAppointment,
          appointmentId: appointmentsData.appointmentCreated.id,
        };
        uploadAppointmentFiles(body);
      }
      setLoading(false);
      history.push(APPOINTMENTS);
    }
  }, [appointmentsData.success.genericMessage]);

  useEffect(() => {
    getUser(session.userType, session.id);
      deleteMessages();
      deleteAttachmentMessages();

    return () => {
      clearInformationAppointment();
      clearPatientAnonymous();
    };
  }, []);

  useEffect(() => {
    if (!isAssistant && userData.user) {
      setPatient({
        patient: userData.user,
        medications: userData.user.medications,
        allergies: userData.user.allergies,
        diseases: userData.user.diseases,
      });
    }
  }, [userData.user]);

  useEffect(() => {
    if (userData.patient_anonymous) {
      console.log(
        'ESTOS SON LOS PACIENTES ANONYMOUS ',
        userData.patient_anonymous
      );
      setIsExistPatient(true);
      setDataPatient({
        name: userData.patient_anonymous.first_name,
        lastName: userData.patient_anonymous.last_name,
        phone: userData.patient_anonymous.telephone,
        email: userData.patient_anonymous.email,
        dateOfBirth: moment(userData.patient_anonymous.date_of_birth).format(
          'YYYY-MM-DD'
        ),
        gender: userData.patient_anonymous.gender,
        id: userData.patient_anonymous.id,
      });
    } else if (userData.patient_anonymous == null) {
      console.log('NO EXISTE PACIENTE ANONIMO!');
      setIsExistPatient(false);
    }
  }, [userData.patient_anonymous]);

  useEffect(() => {
    if (userData.success == 'Paciente anonimo creado con exito') {
      handleCreateAppointmentLight();
    }
  }, [userData.success]);

  useEffect(() => {
    console.log('estos son los allergies array ', patientAllergies);
  }, [patientAllergies]);

  const { user, medications, allergies, diseases } = userData;

  const getUrlAndId = (type, isForDelete) => {
    let dataType = {};
    if (type === 'medications') {
      dataType = {
        id: 'medication_id',
        url: isForDelete ? 'delete_medication' : 'patient_medication',
      };
    } else if (type === 'diseases') {
      dataType = {
        id: 'disease_id',
        url: isForDelete ? 'delete_disease' : 'patient_disease',
      };
    } else if (type === 'allergies') {
      dataType = {
        id: 'allergie_id',
        url: isForDelete ? 'delete_allergie' : 'patient_allergie',
      };
    }
    return dataType;
  };

  const handleUserMedication = (isNew, med, isForDelete = false) => {
    const infoToUpdate = 'medications';
    const data = getUrlAndId(infoToUpdate, isForDelete);
    if (!isForDelete) {
      if (isNew) {
        createInfo(infoToUpdate, { name: med.name }, data, isAssistant);
      } else {
        addUserInfo(infoToUpdate, med);
      }
    } else {
      deleteUserInfo(infoToUpdate, med.id);
    }
  };

  const handleUserDisease = (isNew, disease, isForDelete = false) => {
    const infoToUpdate = 'diseases';
    const data = getUrlAndId(infoToUpdate, isForDelete);
    if (!isForDelete) {
      if (isNew) {
        createInfo(infoToUpdate, { name: disease.name }, data, isAssistant);
      } else {
        addUserInfo(infoToUpdate, disease);
      }
    } else {
      deleteUserInfo(infoToUpdate, disease.id);
    }
  };

  const handleUserAllergie = (isNew, allergie, isForDelete = false) => {
    const infoToUpdate = 'allergies';
    const data = getUrlAndId(infoToUpdate, isForDelete);
    if (!isForDelete) {
      if (isNew) {
        createInfo(infoToUpdate, { name: allergie.name }, data, isAssistant);
      } else {
        addUserInfo(infoToUpdate, allergie, data);
      }
    } else {
      deleteUserInfo(infoToUpdate, allergie.id, data);
    }
  };

  const addInformation = {
    handleUserMedication,
    handleUserAllergie,
    handleUserDisease,
  };

  const handleInjuredAreaChange = (e) => {
    setInjuredArea(e.target.value);
    console.log(e.target.value);
  };

  const handlePhysicalExaminationChange = (e) => {
    setPhysicalExamination(e.target.value);
    console.log(e.target.value);
  };

  const handleSymptomsChange = (e) => {
    setSymptoms(e.target.value);
    console.log(e.target.value);
  };

  const handleSymptomsTimeChange = (e) => {
    setSymptomsTime(e.target.value);
    console.log(e.target.value);
  };

  const handleSpo2Change = (e) => {
    setSpo2(e.target.value);
    console.log(e.target.value);
  };

  const handleGlucoseChange = (e) => {
    setGlucose(e.target.value);
    console.log(e.target.value);
  };

  const handleSystolicPressureChange = (e) => {
    setSystolicPressure(e.target.value);
    console.log(e.target.value);
  };

  const handleDiastolicPressureChange = (e) => {
    setDiastolicPressure(e.target.value);
    console.log(e.target.value);
  };

  const handleHeartRateChange = (e) => {
    setHeartRate(e.target.value);
    console.log(e.target.value);
  };

  const handleTemperatureChange = (e) => {
    setTemperature(e.target.value);
    console.log(e.target.value);
  };

  const handleRespiratoryRateChange = (e) => {
    setRespiratoryRate(e.target.value);
  }

  const handleAttachmentsChange = (files) => {
    if (files.length !== 0) {
      if (uploadingAttachmentConsent) {
        setConsentFile(files[0]);
      } else if (uploadingAttachmentStudies) {
        setAttachments(files);
      }
      console.log(files);
    }
  };

  const handleInputCHange = (e) => {
    setInput(e.target.value);
    console.log(e.target.value);
  };

  const handleCheckChange = (event) => {
    setChecked(event.target.checked);
    console.log(event.target.checked);
  };

  const handleCreateAppointmentLight = () => {
    setButtonClicked(true);
    createAppointmentLight(
      location.state.schedule.id,
      input,
      location.state.schedule.doctor.id,
      userData.patient_anonymous.id,
      session.accessToken,
      appointmentsData.allergies,
      appointmentsData.medications,
      appointmentsData.diseases,
      injuredArea,
      physicalExamination,
      symptoms,
      symptomsTime,
      spo2,
      glucose,
      systolicPressure,
      diastolicPressure,
      heartRate,
      temperature,
      respiratoryRate,
    );
  };

  const handleAttachConsent = () => {
    setAttachmentModalOpen(true);
    setUploadingAttachmentConsent(true);
    setUploadingAttachStudies(false);
  }

  const handleAttachStudies = () => {
    setAttachmentModalOpen(true);
    setUploadingAttachmentConsent(false);
    setUploadingAttachStudies(true);
  }

  const handleAttachmentsAccept = () => {
    setUploadingAttachmentConsent(false);
    setUploadingAttachStudies(false);
    setAttachmentModalOpen(false);
  }

  const handleAttachCancel = () => {
    if (uploadingAttachmentConsent) {
      setConsentFile(null);
    } else if (uploadingAttachmentStudies) {
      setAttachments([]);
    }
    setUploadingAttachmentConsent(false);
    setUploadingAttachStudies(false);
    setAttachmentModalOpen(false);
  }

  const handleSetPatientInfo = (value) => {
    if (value == null) {
      setPatient({
        patient: null,
        medications: null,
        allergies: null,
        diseases: null,
      });
    } else {
      setPatient({
        patient: value,
        medications: value.medications,
        allergies: value.allergies,
        diseases: value.diseases,
      });
    }
  };

  const handleCancelAppointment = () => {
    if (isAssistant || isOperator) {
      // deleteSchedule('token', location.state.schedule.id, false);
      history.push(AGENDA);
    } else {
      history.push(APPOINTMENTS);
    }
  };

  const handleGetPatientAnonymous = (e) => {
    e.preventDefault();
    setDataPatient({
      name: null,
      lastName: null,
      phone: null,
      email: null,
      dateOfBirth: moment().add(-18, 'years').format('YYYY-MM-DD'),
      gender: null,
      id: null,
    });
    if (identity_document) {
      getPatientAnonymous(identity_document);
    }
  };

  const isOlderThan18 = (dateOfBirth) => {
    const today = moment();
    const diff = today.diff(moment(dateOfBirth), 'years');
    return diff >= 18;
  };

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handlePatientAnonymous = (update = false) => {
    const body = {
      email,
      first_name: name,
      last_name: lastName,
      identity_document: identity_document,
      date_of_birth: moment(dateOfBirth).format('YYYY-MM-DD'),
      gender,
      telephone: phone,
    };

    if (update) {
      updatePatientAnonymous(dataPatient.id, body);
    } else {
      createPatientAnonymous(body);
    }
  };

  const ClipboardCopy = ({ copyText }) => {
    const [isCopied, setIsCopied] = useState(false);

    // This is the function we wrote earlier
    async function copyTextToClipboard(text) {
      if ('clipboard' in navigator) {
        return await navigator.clipboard.writeText(text);
      } else {
        return document.execCommand('copy', true, text);
      }
    }

    // onClick handler function for the copy button
    const handleCopyClick = () => {
      // Asynchronously call copyTextToClipboard
      copyTextToClipboard(copyText)
        .then(() => {
          // If successful, update the isCopied state value
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 1500);
        })
        .catch((err) => {
          console.log(err);
        });
    };
  };
  return (
    <>
      <DoctariModal
        open={attachmentModalOpen}
        setOpen={(val) => setAttachmentModalOpen(val)}
        title={uploadingAttachmentConsent ? 'Adjuntar consentimiento' : 'Adjuntar estudios'}
      >
        <DropzoneArea
          useChipsForPreview={true}
          dropzoneText={
            'Haz click aquí o arrastra tus archivos para adjuntarlos'
          }
          onChange={(files) => handleAttachmentsChange(files)}
          onDelete={(file) => console.log(file)}
          clearOnUnmount={false}
          filesLimit={uploadingAttachmentConsent ? 1 : 3}
          initialFiles={uploadingAttachmentConsent ? consentFile : attachments}
          getFileAddedMessage={(file) => `${file} añadido`}
          getFileRemovedMessage={(file) => `${file} eliminado`}
          getFileLimitExceedMessage={(limit) =>
            `Limite de archivos excedido, el limite es de ${limit} archivos`
          }
        />
        <Button
          style={{ float: 'right', margin: '10px' }}
          variant='contained'
          color='primary'
          disabled={!attachments.length && consentFile === null}
          onClick={handleAttachmentsAccept}
        >
          Aceptar
        </Button>
        <Button
          style={{ float: 'right', margin: '10px' }}
          onClick={handleAttachCancel}
          variant='outlined'
          color='primary'
        >
          Cancelar
        </Button>
      </DoctariModal>

      <Grid
        container
        direction='column'
        justifyContent='center'
        alignItems='center'
      >
        <Grid
          item
          xs={12}
          md={12}
          justifyContent='space-between'
          className={styles.menuContainer}
        >
          <h2 className={styles.title}>Crear consulta</h2>
          <CardHeader
            avatar={
              <Avatar
                alt='Foto de perfil'
                src={
                  location.state.schedule.doctor.profile_picture
                    ? location.state.schedule.doctor.profile_picture.url
                    : null
                }
                className={styles.avatar}
              />
            }
            title={location.state.schedule.doctor.full_name}
            subheader={location.state.schedule.doctor.specialty.name}
          />
        </Grid>
        <Grid item className={styles.formConteiner}>
          <Paper elevation={8} style={{ padding: '40px 40px' }}>
            <Grid item container spacing={2} className={styles.testContainer}>
              <Grid className={styles.firstPaperContainer}>
                <p>
                  <b>Fecha de consulta:</b>
                  {` ${moment(location.state.schedule.start)
                    .tz(moment.tz.guess())
                    .format('YYYY-MM-DD HH:mm [hs]')}`}
                </p>
              </Grid>
              <Grid item md={12} xs={12} style={{ height: '4rem' }}>
                <form onSubmit={handleGetPatientAnonymous}>
                  {/* <Grid
                    container
                    direction="row"
                    // justifyContent="center"
                    // alignItems="center"
                  > */}
                  <Grid item md={6} xs={12} className={styles.paperGridItems}>
                    <FormControl
                      className={styles.formControl}
                      error={identity_document === ''}
                    >
                      <TextField
                        id='my-input'
                        // label="Ingrese documento del paciente *"
                        // type="date"
                        placeholder='Ingrese documento del paciente *'
                        variant='standard'
                        autoComplete='off'
                        defaultValue={identity_document}
                        onChange={(e) => setIdentityDocument(e.target.value)}
                        // InputProps={{
                        //   endAdornment: (
                        //     <InputAdornment position="start">
                        //       <SearchIcon />
                        //     </InputAdornment>
                        //   ),
                        // }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment>
                              <IconButton
                                className={styles.iconSearchButton}
                                onClick={handleGetPatientAnonymous}
                              >
                                <SearchOutlined />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      // error={!isOlderThan18(dateOfBirth)}
                      />

                      {/* <InputLabel htmlFor="my-input">
                          Ingrese documento del paciente *
                        </InputLabel>
                        <Input
                          id="my-input"
                          aria-describedby="my-helper-text"
                          onChange={(e) => setIdentityDocument(e.target.value)}
                          value={identity_document}
                          required
                        /> */}
                    </FormControl>
                  </Grid>
                  {/* <Grid
                      container
                      item
                      md={6}
                      xs={12}
                      justifyContent="center"
                      alignItems="center"
                      className={styles.paperGridItems}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        //onClick={handleLogin}
                        disabled={identity_document == ''}
                      >
                        BUSCAR
                      </Button>
                    </Grid> */}
                  {/* </Grid> */}
                </form>
              </Grid>
              <Grid item md={6} xs={12} className={styles.paperGridItems}>
                <FormControl
                  className={styles.formControl}
                  error={name === ''}
                // disabled={isExistPatient}
                >
                  <InputLabel htmlFor='my-input'>Nombre *</InputLabel>
                  <Input
                    id='my-input'
                    aria-describedby='my-helper-text'
                    autoComplete='off'
                    onChange={(e) =>
                      setDataPatient({ ...dataPatient, name: e.target.value })
                    }
                    value={name || ''}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item md={6} xs={12} className={styles.paperGridItems}>
                <FormControl
                  className={styles.formControl}
                  error={lastName === ''}
                // disabled={isExistPatient}
                >
                  <InputLabel htmlFor='my-input'>Apellido *</InputLabel>
                  <Input
                    id='my-input'
                    aria-describedby='my-helper-text'
                    autoComplete='off'
                    onChange={(e) =>
                      setDataPatient({
                        ...dataPatient,
                        lastName: e.target.value,
                      })
                    }
                    value={lastName || ''}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item md={6} xs={12} className={styles.paperGridItems}>
                <FormControl
                  className={styles.formControl}
                  error={email && !validateEmail(email)}
                // disabled={isExistPatient}
                >
                  <InputLabel htmlFor='my-input'>Email *</InputLabel>
                  <Input
                    id='my-input'
                    aria-describedby='my-helper-text'
                    autoComplete='off'
                    onChange={(e) =>
                      setDataPatient({ ...dataPatient, email: e.target.value })
                    }
                    value={email || ''}
                    required
                  />
                  {email && !validateEmail(email) && (
                    <FormHelperText id='standard-adornment-password-text' error>
                      Formato inválido
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item md={6} xs={12} className={styles.paperGridItems}>
                <FormControl className={styles.formControl}>
                  <TextField
                    id='date'
                    label='Fecha de nacimiento *'
                    type='date'
                    value={dateOfBirth}
                    onChange={(e) =>
                      setDataPatient({
                        ...dataPatient,
                        dateOfBirth: e.target.value,
                      })
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // disabled={isExistPatient}
                    error={!isOlderThan18(dateOfBirth)}
                  />
                  {!isOlderThan18(dateOfBirth) && (
                    <FormHelperText error>
                      Debe ser mayor de 18 años
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item md={6} xs={12} className={styles.paperGridItems}>
                <FormControl
                  className={styles.formControl}
                // disabled={isExistPatient}
                >
                  <InputLabel htmlFor='my-input-phone'>
                    Número de teléfono
                  </InputLabel>
                  <Input
                    id='my-input-phone'
                    aria-describedby='my-helper-text'
                    autoComplete='off'
                    onChange={(e) =>
                      setDataPatient({ ...dataPatient, phone: e.target.value })
                    }
                    value={phone || ''}
                  // required
                  />
                </FormControl>
              </Grid>

              <Grid
                item
                container
                md={6}
                xs={12}
                justifyContent='center'
                alignItems='center'
                className={styles.paperGridItems}
              >
                <FormControl
                  className={styles.formControl}
                  style={{
                    marginBottom: '0rem',
                    width: 'fit-content',
                  }}
                  error={gender === ''}
                // disabled={isExistPatient}
                >
                  <FormLabel component='legend'>Género *</FormLabel>
                  <RadioGroup
                    aria-label='gender'
                    name='gender1'
                    onChange={(e) =>
                      setDataPatient({ ...dataPatient, gender: e.target.value })
                    }
                    value={gender}
                    row
                  >
                    <FormControlLabel
                      value='F'
                      control={<Radio />}
                      label='Femenino'
                    />
                    <FormControlLabel
                      value='M'
                      control={<Radio />}
                      label='Masculino'
                    />
                    <FormControlLabel
                      value='O'
                      control={<Radio />}
                      label='Otro'
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item md={12} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Motivo de la consulta'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleInputCHange}
                />
              </Grid>
              <Grid item md={6} xs={12} className={styles.paperGridItems}>
                <AutocompleteInfo
                  label={'Alergias'}
                  optionList={allergies}
                  valuesSelected={appointmentsData.allergies}
                  setNewValue={(allergie) => {
                    const isNew = true;
                    addInformation.handleUserAllergie(isNew, allergie);
                  }}
                  addValue={(allergie) => {
                    const isNew = false;
                    addInformation.handleUserAllergie(isNew, allergie);
                  }}
                  deleteValue={(allergie) => {
                    const isNew = false;
                    const isForDelete = true;
                    addInformation.handleUserAllergie(
                      isNew,
                      allergie,
                      isForDelete
                    );
                  }}
                // isAssistant={isAssistant}
                />
              </Grid>
              <Grid item md={6} xs={12} className={styles.paperGridItems}>
                <AutocompleteInfo
                  label={'Enfermedades'}
                  optionList={diseases}
                  valuesSelected={appointmentsData.diseases}
                  setNewValue={(disease) => {
                    const isNew = true;
                    addInformation.handleUserDisease(isNew, disease);
                  }}
                  addValue={(disease) => {
                    const isNew = false;
                    addInformation.handleUserDisease(isNew, disease);
                  }}
                  deleteValue={(disease) => {
                    const isNew = false;
                    const isForDelete = true;
                    addInformation.handleUserDisease(
                      isNew,
                      disease,
                      isForDelete
                    );
                  }}
                // isAssistant={isAssistant}
                />
              </Grid>
              <Grid item md={6} xs={12} className={styles.paperGridItems}>
                <AutocompleteInfo
                  label={'Medicamentos'}
                  optionList={medications}
                  valuesSelected={appointmentsData.medications}
                  setNewValue={(med) => {
                    const isNew = true;
                    addInformation.handleUserMedication(isNew, med);
                  }}
                  addValue={(med) => {
                    const isNew = false;
                    addInformation.handleUserMedication(isNew, med);
                  }}
                  deleteValue={(med) => {
                    const isNew = false;
                    const isForDelete = true;
                    addInformation.handleUserMedication(
                      isNew,
                      med,
                      isForDelete
                    );
                  }}
                // isAssistant={isAssistant}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Lesión'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleInjuredAreaChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Examen físico'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handlePhysicalExaminationChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Síntomas'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleSymptomsChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Tiempo de los síntomas'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleSymptomsTimeChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='SPO2 (%)'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleSpo2Change}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Glucosa en sangre (mg/dl)'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleGlucoseChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Presión Sistólica (mm Hg)'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleSystolicPressureChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Presión Diástolica (mm Hg)'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleDiastolicPressureChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Frecuencia Cardíaca (ppm)'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleHeartRateChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Temperatura (°C)'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleTemperatureChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Frecuencia Respiratoria (rpm)'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleRespiratoryRateChange}
                />
              </Grid>

              <div className={styles.forthtPaperContainer}>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color='primary'
                        checked={checked}
                        onChange={handleCheckChange}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    }
                    label='Aceptar los términos,condiciones y consentimiento informado.'
                  />
                </Grid>
                <Grid item>
                  <Button
                    variant='outlined'
                    className={styles.buttons}
                    color='primary'
                    style={{ marginRight: '10px' }}
                    onClick={() => handleAttachConsent()}
                  >
                    Adjuntar consentimiento
                  </Button>
                  <Button
                    variant='outlined'
                    className={styles.buttons}
                    color='primary'
                    style={{ marginRight: '10px' }}
                    onClick={() => handleAttachStudies()}
                  >
                    Adjuntar estudios
                  </Button>
                  <Button
                    variant='outlined'
                    className={styles.buttons}
                    color='primary'
                    onClick={handleCancelAppointment}
                  >
                    Cancelar
                  </Button>
                  <Button
                    disabled={
                      !isOlderThan18(dateOfBirth) ||
                      !name ||
                      !lastName ||
                      !validateEmail(email) ||
                      !gender ||
                      !checked ||
                      !identity_document
                      // || consentFile === null
                    }
                    variant='contained'
                    className={styles.buttons}
                    color='primary'
                    onClick={
                      () => {
                        setLoading(true);
                        // if (isExistPatient) {
                        //   handleCreateAppointmentLight();
                        //   handlePatientAnonymous(true);
                        // } else {
                        // }
                        handlePatientAnonymous();
                      }
                      //setButtonClicked(true)
                      //setCreateAppointmentModalOpen(true)
                    }
                  >
                    {loading ? 'Cargando...' : 'Crear consulta'}
                  </Button>
                </Grid>
              </div>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

const mapStateToProps = ({ session, user, appointments, doctors }) => {
  return {
    session,
    userData: user,
    appointmentsData: appointments,
    doctors,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUser: (type, id, token) =>
    dispatch({
      type: userActionsTypes.GET_USER,
      payload: { type, id },
    }),
  addUserInfo: (type, newValue) =>
    dispatch({
      type: appointmentActionsTypes.ADD_INFORMATION_APPOINTMENT,
      payload: { type, newValue },
    }),
  createInfo: (type, body, data, isAssistant) =>
    dispatch({
      type: userActionsTypes.CREATE_INFORMATION,
      payload: { type, body, data, isAssistant },
    }),
  deleteUserInfo: (type, id) =>
    dispatch({
      type: appointmentActionsTypes.DELETE_INFORMATION_APPOINTMENT,
      payload: { type, id },
    }),
  createAppointmentLight: (
    scheduleId,
    reason,
    doctor,
    patient,
    token,
    allergiesObjects,
    medicationsObjects,
    diseasesObjects,
    injuredArea,
    physicalExamination,
    symptoms,
    symptomsTime,
    spo2,
    glucose,
    systolicPressure,
    diastolicPressure,
    heartRate,
    temperature,
  ) =>
    dispatch({
      type: appointmentActionsTypes.CREATE_APPOINTMENT_LIGHT,
      payload: {
        scheduleId,
        reason,
        doctor,
        patient,
        token,
        allergiesObjects,
        medicationsObjects,
        diseasesObjects,
        injuredArea,
        physicalExamination,
        symptoms,
        symptomsTime,
        spo2,
        glucose,
        systolicPressure,
        diastolicPressure,
        heartRate,
        temperature,
      },
    }),
  uploadAppointmentFiles: (body) =>
    dispatch({
      type: appointmentActionsTypes.UPLOAD_APPOINTMENT_FILES,
      payload: { body },
    }),
  uploadConsentFile: (body) =>
    dispatch({
      type: appointmentActionsTypes.UPLOAD_APPOINTMENT_CONSENT_FILE,
      payload: { body },
    }),
  deleteAttachmentMessages: () =>
    dispatch({
      type: appointmentActionsTypes.DELETE_ATTACHMENT_MESSAGES,
    }),
  deleteMessages: () =>
    dispatch({
      type: appointmentActionsTypes.DELETE_MESSAGES,
    }),
  deleteSchedule: (token, scheduleId, isMultiple) =>
    dispatch({
      type: appointmentActionsTypes.DELETE_SCHEDULE,
      payload: {
        token,
        scheduleId,
        isMultiple,
      },
    }),
  getPatientAnonymous: (id) =>
    dispatch({
      type: userActionsTypes.GET_PATIENT_ANONYMOUS,
      payload: { id },
    }),
  createPatientAnonymous: (body) =>
    dispatch({
      type: userActionsTypes.CREATE_PATIENT_ANONYMOUS,
      payload: { body },
    }),
  clearInformationAppointment: () =>
    dispatch({
      type: appointmentActionsTypes.CLEAR_INFORMATIONS_APPOINTMENT,
    }),
  clearPatientAnonymous: () =>
    dispatch({
      type: userActionsTypes.CLEAR_PATIENT_ANONYMOUS,
    }),
  updatePatientAnonymous: (id, body) => {
    dispatch({
      type: userActionsTypes.UPDATE_PATIENT_ANONYMOUS,
      payload: { id, body },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentLight);
